import React, { Component } from 'react';
import cx from 'classnames';
import Moment from 'moment';
import { isTouchDevice } from '../../utilities/feature-tests';

import { getDayNames } from './utils';

const DEPARTURE = 0;
const RETURNING = 1;

class DatePickerCalendarMonth extends Component {
  render() {
    const { month } = this.props;

    return (
      <div className='DatePickerCalendarMonth'>
        <h2 className='DatePickerCalendarMonth-month u-titleSection'>
          { month.monthName }
          <span className='DatePickerCalendarMonth-year'>
            { month.year }
          </span>
        </h2>
        <ol className='DatePickerCalendarMonth--weekdayList DatePickerCalendarHeader-weekdayList'>
          { this.renderWeekdays() }
        </ol>
        <ol
          key={ month.monthNumber }
          className='DatePickerCalendarMonth-dayList'>
          { this.renderDays() }
        </ol>
      </div>
    );
  }

  renderWeekdays() {
    const { language, storefront  } = this.props;

    return getDayNames(storefront, language).map((day, i) =>
      (<li key={ i } className='DatePickerCalendarHeader-weekdayListItem'>
        { day.charAt(0) }
      </li>)
    );
  }

  renderDays() {
    const {
      calendarHotel,
      currentLeg,
      hoveredDate,
      isMulticity,
      itinerary,
      month,
      multiCityItineraries,
      multiCitySelectorIndex,
      storefront,
    } = this.props;

    const selectedFirstLegDate = itinerary[DEPARTURE];
    const selectedLastLegDate = itinerary[RETURNING];
    const multicityDateSelected = multiCityItineraries && multiCitySelectorIndex > 0 && multiCityItineraries[multiCitySelectorIndex - 1];

    return month.days.map((day, i) => {
      const { dayNumber, isInactive } = day;
      const isEmptyDay = !dayNumber;

      const dayMoment = Moment({
        day: dayNumber,
        month: month.monthNumber,
        year: month.year,
      });

      const mondayFirstDay = i % 7 === 5 || i % 7 === 6;
      const sundayFirstDay = i % 7 === 0 || i % 7 === 6;
      const storefrontENSunday = storefront === 'nl' || storefront === 'us' ||  storefront === 'eu' ||  storefront === 'gb' ||  storefront === 'ca'  ||  storefront === 'jp'  ;
      const isWeekend = storefrontENSunday ? sundayFirstDay : mondayFirstDay;

      const isSelected = !isEmptyDay
        && (dayMoment.isSame(selectedFirstLegDate, 'day')
        || dayMoment.isSame(selectedLastLegDate, 'day'));

      const isSelectedReturnDay = !isEmptyDay
        && dayMoment.isSame(selectedLastLegDate, 'day');

      const isBetweenSelectedDays = selectedFirstLegDate !== null
        && selectedLastLegDate !== null
        && dayMoment.isAfter(selectedFirstLegDate)
        && dayMoment.isBefore(selectedLastLegDate);

      const isInbetweenDay = !isEmptyDay
        && selectedFirstLegDate
        && hoveredDate
        && dayMoment.isBefore(hoveredDate, 'day')
        && dayMoment.isAfter(selectedFirstLegDate, 'day');

      let isUnavailable = false;

      if (selectedFirstLegDate && calendarHotel) {
        if (dayMoment.toDate().getTime() > selectedFirstLegDate.toDate().getTime() + (30 * 24 * 60 * 60 * 1000) ) {
          isUnavailable = true;
        } else {
          isUnavailable = isInactive
            || (dayMoment.isBefore(selectedFirstLegDate) && currentLeg === RETURNING);
        }
      } else if (isMulticity && multicityDateSelected && multicityDateSelected.date ) {
        if ( dayMoment.isBefore(multicityDateSelected.date)) {
          isUnavailable = true;
        }
      } else {
        isUnavailable = isInactive
          || (dayMoment.isBefore(selectedFirstLegDate) && currentLeg === RETURNING);
      }

      const dayClasses = cx({
        'DatePickerCalendarMonth-dayListItem': true,
        'DatePickerCalendarMonth-dayListItem--weekend': isWeekend,
        'is-selected': isSelected,
        'is-disabled': isUnavailable,
        'is-selected-return-day': isSelectedReturnDay,
        'isBetweenSelectedDays': isInbetweenDay || isBetweenSelectedDays,
      });

      return (
        <li key={ i } className={ dayClasses }>
          { isUnavailable ?
            this.renderDisabledDay(day) : this.renderEnabledDay(day) }
        </li>
      );
    });
  }

  renderEnabledDay(day) {
    const {
      currentLeg,
      itinerary,
      month,
      noButton,
      onMouseLeave,
    } = this.props;

    const dayMoment = Moment({
      day: day.dayNumber,
      month: month.monthNumber,
      year: month.year,
    });

    const isEmptyDay = !day.dayNumber;
    const isSelectedDepartureDay = dayMoment.isSame(itinerary[DEPARTURE], 'day') && !isEmptyDay;
    const isSelectedReturningDay = dayMoment.isSame(itinerary[RETURNING], 'day') && !isEmptyDay;

    const dayClasses = cx({
      'Icon': true,
      'Icon--arrowRight': !isSelectedReturningDay && (isSelectedDepartureDay || currentLeg === DEPARTURE),
      'Icon--arrowLeft': !isSelectedDepartureDay && (isSelectedReturningDay || currentLeg === RETURNING),
    });

    const FormComponent = noButton ? 'div' : 'button';

    return (
      <div className='DatePickerCalendarMonth-wrapDay'>
        <FormComponent
          className='DatePickerCalendarMonth-day'
          onBlur={ onMouseLeave }
          onClick={ () => this.handleDatePicked(day) }
          onMouseEnter={ () => this.handleDayMouseOver(day) }
          onMouseLeave={ onMouseLeave }>
          <div className='DatePickerCalendarMonth-dayContent'>
            <h4 className='DatePickerCalendarMonth-dayNumber'>{ day.dayNumber }</h4>
            <span className={ dayClasses }/>
          </div>
        </FormComponent>
      </div>
    );
  }

  renderDisabledDay(day) {
    return (
      <div className='DatePickerCalendarMonth-wrapDay'>
        <div className='DatePickerCalendarMonth-day'>
          <div className='DatePickerCalendarMonth-dayContent'>
            <h4 className='DatePickerCalendarMonth-dayNumber'>{ day.dayNumber }</h4>
          </div>
        </div>
      </div>
    );
  }

  handleDatePicked(day) {
    const {
      currentLeg,
      handleDatePicked,
      itinerary,
      month,
    } = this.props;

    const newItinerary = itinerary;

    const dayMoment = Moment({
      day: day.dayNumber,
      month: month.monthNumber,
      year: month.year,
    });

    if ( currentLeg === DEPARTURE) {
      newItinerary[DEPARTURE] = dayMoment;
      newItinerary[RETURNING] = null;
    } else {
      newItinerary[RETURNING] = dayMoment;
    }

    handleDatePicked(newItinerary);
  }

  /**
   * @param {CalendarDay} day - day data object
   */
  handleDayMouseOver(day) {
    const { month, onDayMouseOver } = this.props;

    const hoveredDate = Moment({
      day: day.dayNumber,
      month: month.monthNumber,
      year: month.year,
    }).toDate();

    if (!isTouchDevice() ) {
      onDayMouseOver(hoveredDate);
    }
  }
}

export default DatePickerCalendarMonth;
